import { type FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { buildPortalAssetUrl } from 'shared/utils/helpers';
import { formatDayMonth } from 'shared/utils/dateHelpers';

import styles from './PeriodDisplay.module.css';

interface PeriodDisplayProps {
  startDate: string;
  endDate: string;
  isFinished?: boolean;
}

const PeriodDisplay: FC<PeriodDisplayProps> = ({ startDate, endDate, isFinished = false }) => {
  const periodIconUrl = useMemo(() => buildPortalAssetUrl('/campaigns/icons/IconsPeriod.svg'), []);
  const { t } = useTranslation();
  const formattedStartDate = formatDayMonth(new Date(startDate));
  const formattedEndDate = formatDayMonth(new Date(endDate));
  
  const periodDisplay = startDate && endDate
    ? (startDate === endDate ? endDate : `${formattedStartDate} - ${formattedEndDate}`)
    : 'N/A';
    
  return (
    <div className={styles.periodDisplay} data-finished={isFinished}>
      {isFinished 
        ? <span>{t('campaigns.finished', 'Finished').toUpperCase()}</span> 
        : <>
            <img src={periodIconUrl} alt="period" className={styles.periodIcon} />
            <span>{periodDisplay}</span>
          </>
        }
    </div>
  );
};

export default PeriodDisplay;
